class Tabs {
    constructor() {
        this.tabContainers = document.querySelectorAll('.js-tabs');
        this.tabbedFlags = document.querySelectorAll('.js-tabbed-flags');
    }

    init() {
        if (this.tabContainers.length > 0) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.tabbedFlags.forEach(container => {
            container.parentElement.swiper.on('slideChange', (swiper) => {
                container.querySelectorAll('.tabbed-flag').forEach(flag => flag.classList.remove('is-active'));
                container.querySelector('[data-index="' + (swiper.realIndex + 1) + '"]').classList.add('is-active');
            });
            container.addEventListener('click', (event) => {
                let element = event.target;

                if (element.classList.contains('tabbed-flag')) {
                    container.querySelectorAll('.tabbed-flag').forEach(flag => flag.classList.remove('is-active'));
                    element.classList.add('is-active');
                    container.parentElement.swiper.slideTo(parseInt(element.dataset.index));
                }

                this.updateHash(element.id)
            });
        });

        this.tabContainers.forEach(container => {
            container.addEventListener('click', (event) => {
                let element;

                if (event.target.dataset.hasOwnProperty('tab')) {
                    element = event.target;
                } else if (event.target.parentElement.dataset.hasOwnProperty('tab')) {
                    element = event.target.parentElement;
                }

                if (element && element.dataset.hasOwnProperty('tab')) {
                    const activeIndex = parseInt(element.dataset.tab);
                    const tabContents = container.querySelectorAll('[data-tab-content]');
                    const tabNavigationItems = container.querySelectorAll('[data-tab]');

                    container.dataset.activeTab = activeIndex;

                    tabContents.forEach((content, i) => {
                        if (activeIndex === i + 1) {
                            content.classList.add('is-active');

                            // tell the document that a tab has changed
                            let event = new CustomEvent('tab-changed', {
                                detail: {
                                    tab: content
                                }
                            });
                            document.dispatchEvent(event);
                        } else {
                            content.classList.remove('is-active');
                        }
                    });

                    tabNavigationItems.forEach((tabNavigationItem, i) => {
                        if (activeIndex === i + 1) {
                            tabNavigationItem.classList.add('is-active');

                            this.updateHash(tabNavigationItem.id);
                        } else {
                            tabNavigationItem.classList.remove('is-active');
                        }
                    });
                }
            });
        });
        
        this.activeTabfromHash();

        window.addEventListener('hashchange', () => {
            this.activeTabfromHash();
        });
        
    }

    activeTabfromHash() {
      if (window.location.href.indexOf('#') !== -1) {
        let anchor = window.location.href.slice(window.location.href.indexOf('#') + 1);
        console.log(anchor)
        const activeTab = document.querySelector('#' + anchor + '[data-tab]');
        console.log(activeTab)

          if (activeTab) {
              activeTab.click();
          }
      }
    }

    updateHash(tabId) {
      history.replaceState(null, null, '#' + tabId);
    }
}

export default new Tabs();
